import { Raycaster, Vector3 } from "three"
import C from "./Constants"
import gsap from 'gsap'
import GTag from "../utils/GTag"
import Constants from "./Constants"

export default class MegaRaycaster
{
    constructor(_options)
    {
        this.time = _options.time
        this.database = _options.database
        this.ui = _options.ui
        this.cursor = _options.cursor
        this.camera = _options.camera
        this.layout = _options.layout
        this.bottles = _options.bottles
        this.raycastObjects = _options.raycastObjects
        this.highlighter = _options.highlighter

        this.raycaster = new Raycaster()
        this.lastRaycast = Date.now()
        this.lastPointedId = undefined
        this.lastClickedId = undefined

        this.isClicked = false

        this.setClick()
        this.setRaycast()
    }

    setClick()
    {
        this.cursor.on('3dclick', () => this.manageClick())
        document.getElementById('close_details_btn').addEventListener('click', () => { this.unclick() })
    }

    setRaycast()
    {
        this.time.on('tick', () =>
        {
            if(C.VARS.slideMenuOpen || this.isClicked || this.cursor.drag)
            {
                return
            }

            if(Date.now() - this.lastRaycast > C.RAYCAST.raycastInterval)
            {
                this.manageHighlight()

                this.lastRaycast = Date.now()
            }
        })
    }

    getIntersection()
    {
        this.raycaster.setFromCamera(this.cursor, this.camera.instance)
        const intersection = this.raycaster.intersectObjects(this.raycastObjects)[0]
        return intersection ? ({ mesh: intersection.object, point: intersection.point }) : undefined
    }

    manageHighlight(key)
    {
        let pointedItem // Nome dell'uva o del vino o dell'edificio puntato
        let pointedPoint // Posizione dell'oggetto puntato

        if(!key)
        {
            const intersection = this.getIntersection()
            pointedItem = intersection === undefined ? undefined : this.database.getItemFromMesh(intersection.mesh.name)
            pointedPoint = intersection === undefined ? undefined : intersection.point
        }
        else
        {
            pointedItem = this.database.getItemFromId(key)
            const meshName = this.database.getMeshesFromId(key)[0]
            const mesh = this.layout.getMesh(meshName)
            pointedPoint = new Vector3()
            if(mesh !== undefined) mesh.geometry.boundingBox.getCenter(pointedPoint)
        }

        const isClickable = pointedItem !== undefined

        // Change cursor
        document.querySelector('#webgl').style.cursor = isClickable ? 'pointer' : 'grab'

        if(!isClickable)
        {
            this.highlighter.unlightMesh(this.lastPointedId)
            this.lastPointedId = undefined
        }
        else if(pointedItem.id !== this.lastPointedId)
        {
            this.highlighter.unlightMesh(this.lastPointedId)

            let showText = true
            if(1 || this.database.isWine(pointedItem.id))
            {
                showText = !key && (!this.isClicked || this.lastPointedId === undefined)
            }
            this.highlighter.highlightMesh(pointedItem, pointedPoint, showText)

            this.lastPointedId = pointedItem.id
        }

        return { isClickable: isClickable, pointedItemId: pointedItem ? pointedItem.id : undefined, pointedPoint: pointedPoint }
    }

    zoomToPoint(point, itemId)
    {
        this.targetDestination = new Vector3().copy(point)
        this.zoomVal = C.VARS.isMobile ? C.CAMERA.clickDistanceMobile : C.CAMERA.clickDistanceDesktop

        const wine = this.database.getWineFromId(itemId)
        if(wine !== undefined)
        {
            this.targetDestination.y += this.bottles.getBottleHeight() * 0.5
        }
        else
        {
            this.zoomVal *= 0.2
        }

        this.targetDestination.clamp(C.SCENE.minBoundary, C.SCENE.maxBoundary)

        this.camera.controls.isGsapping = true
        gsap.to(this.camera.controls.target, {
            duration: C.CAMERA.clickAnimDuration,
            x: this.targetDestination.x,
            y: this.targetDestination.y,
            z: this.targetDestination.z,
            ease: 'Power2.easeInOut' })

        gsap.to(this.camera.controls, {
            duration: C.CAMERA.clickAnimDuration,
            zoom: this.zoomVal,
            ease: 'Power2.easeInOut' })
            .then(() =>
            {
                this.camera.controls.isGsapping = false
            })
    }

    manageClick(key)
    {
        this.ui.interruptAutoclick()

        const highlighted = this.manageHighlight(key)

        // Change cursor
        document.querySelector('#webgl').style.cursor = 'grab'

        if(this.lastClicked === highlighted.pointedItemId) return

        if(highlighted.isClickable)
        {
            this.bottles.hideBottle()

            this.isClicked = true

            document.documentElement.style.cursor = 'default'

            this.highlighter.showBottle(highlighted.pointedItemId, highlighted.pointedPoint)

            this.zoomToPoint(highlighted.pointedPoint, highlighted.pointedItemId)

            this.ui.showDetails(highlighted.pointedItemId)

            this.lastClicked = highlighted.pointedItemId

            const item = this.database.getItemFromId(highlighted.pointedItemId)

            if(Constants.VARS.hasAutoclicked)
            {
                GTag.add('autoclick')
                Constants.VARS.hasAutoclicked = false
            }
            else if(item !== undefined)
            {
                if(key === undefined)
                {
                    GTag.add('click_on_field', { 'item': item.name })
                }
                else
                {
                    GTag.add('click_on_footer', { 'item': item.name })
                }
            }
        }
        else
        {
            this.unclick()
        }
    }

    unclick()
    {
        this.isClicked = false
        this.cursor.forceUpdate()
        this.bottles.hideBottle()
        this.highlighter.unlightMesh(this.lastPointedId)
        this.ui.hideDetails()
        this.lastClicked = undefined
    }

    footerListClick(key)
    {
        this.manageClick(Array.isArray(key) ? key[0] : key)
    }
}